import React from 'react';
import Grid from "@material-ui/core/Grid";
import {Link} from "react-router-dom";

import './style.scss';

const CTA = () => {
    return(
        <Grid className="sireUsWrapper">
            <Grid container className="container">
                <Grid item xs={12}>
                    <Grid className="content">
                        <h2> Honestly, it’s that easy. Let’s get you your pay stubs. </h2>
                        <Link to="/contact-us" className="cBtn">Sign Up</Link>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
};

export default CTA;